import { SearchEvents, ResortEventData, SearchResultEvents, ResortPageViews  } from "./resort-custom-events";
import { AppInsightsService } from "microsoft-applicationinsights-angular5";
import { Core } from "../shared/core/ovs.core";
import { ResortSummary } from "../models/presentation.model";
import { UserActivityDataContainer } from "./user-activity-logger.service";
import * as moment from 'moment';

export class ResortInsightsService {
    private static baseEventData: ResortEventData;
    private static appInsights: AppInsightsService;

    public static setBaseEventData(baseEventData: any) {
        this.baseEventData = baseEventData;
    }

    public static intialize(appInsightsService: AppInsightsService) {
        this.appInsights = appInsightsService;
    }

    public static logEvent(eventName, eventData?: any): void {
        let mergedData = this.merge(null, this.baseEventData);

        switch (eventName) {
        case SearchEvents.SearchResultsReceived:
            var results = <ResortSummary[]> eventData;
            var truncatedResults = new Array();
            results.forEach(r => {
                truncatedResults.push(
                    {
                        resortId: r.id,
                        resortName: r.resortName,
                        isPreferred: r.isPreferred,
                        city: r.city,
                        state: r.state,
                        country: r.country,
                        price: r.startingFromPurchase,
                        discount: r.startingFromDiscount
                    }
                );
            });
            ResortInsightsService.appInsights.logEvent(eventName,
                this.merge({ "searchResults": JSON.stringify(truncatedResults) }, mergedData),
                null);
            break;
        default:
            ResortInsightsService.appInsights.logEvent(eventName, this.merge(eventData, mergedData), null);
            break;
        }
    }

    public static logPageView(pageView: string, publishedData?: any, additionalData?: any): void {
        let mergedData = this.merge(null, this.baseEventData);
        let useResortDetailInfoAsSearch = false;

        const mapData = new Map();
        mapData.set("product", "Resort");
        mapData.set("quantity", "1");
        mapData.set("origination", "ICE");
        mapData.set("agentname", this.baseEventData.agentName ? this.baseEventData.agentName : "");
        mapData.set("agentid", this.baseEventData.agentId ? this.baseEventData.agentId : "");
        mapData.set("cobrandid", this.baseEventData.cobrandId ? this.baseEventData.cobrandId : "");
        mapData.set("sessionid", this.baseEventData.sessionId);
        mapData.set("userid", this.baseEventData.nameId ? this.baseEventData.nameId : "");

        if (additionalData && additionalData["order_id"]) {
            mapData.set("bookingid", additionalData["order_id"]);
        }
            

        if (additionalData !== null && additionalData !== undefined) {
            mergedData = this.merge({ "additionalData": JSON.stringify(additionalData) }, mergedData);
        }

        if (publishedData !== null && publishedData !== undefined) {
            let published = publishedData as UserActivityDataContainer;

            // configuration data
            if (published.configuration !== null && published.configuration !== undefined) {

                mapData.set("sessionToken", published.configuration.SessionToken);
                mapData.set("errormessage", published.configuration.ErrorMessage);
                mapData.set("errorredirecturl", published.configuration.ErrorRedirectUrl);
                mapData.set("locale", published.configuration.Locale);
                mapData.set("displayoptionsid", published.configuration.DocOptionId);
                mapData.set("memberclass", published.configuration.MemberClass);
                mapData.set("brand", published.configuration.Brand);

                if (publishedData.configuration.Partner) {
                    mapData.set("ovcpartnerid", published.configuration.Partner.Id);
                    mapData.set("ovcpartner", published.configuration.Partner.LongName);
                }
            }

            //member data
            if (published.member !== null && published.member !== undefined) {
                mergedData = this.merge({ "member": JSON.stringify(published.member) }, mergedData);
                mapData.set("memberid", published.member.Id);
                mapData.set("dbcbalance", published.member.DbcBalance.toString());
                mapData.set("memberaddress", JSON.stringify(published.member.Address));
            }

            //search criteria
            if (published.searchCriteria !== null && published.searchCriteria !== undefined) {

                mergedData = this.merge({ "searchCriteria": JSON.stringify(published.searchCriteria) }, mergedData);

                mapData.set("searchdate",
                    published.searchCriteria.selectedDate !== null
                    ? this.formattedDateTime(published.searchCriteria.selectedDate)
                        : "");
                if ((!ResortPageViews.CheckoutPage.endsWith(pageView) && !ResortPageViews.ConfirmationPage.endsWith(pageView))) {
                    mapData.set("startdate",
                        published.searchCriteria.selectedDate !== null
                        ? this.formattedDateTime(published.searchCriteria.selectedDate)
                        : "");
                }

                if (published.searchCriteria.searchText !== null ||
                    published.searchCriteria.searchText !== undefined ||
                    published.searchCriteria.searchText !== "") {

                    mapData.set("destinationcity",
                        (published.searchCriteria.searchText !== null &&
                            published.searchCriteria.searchText !== undefined)
                        ? published.searchCriteria.searchText
                        : "");
                    mapData.set("lat",
                        (published.searchCriteria.latitude !== null && published.searchCriteria.latitude !== undefined)
                        ? published.searchCriteria.latitude.toString()
                        : "");
                    mapData.set("long",
                        (published.searchCriteria.longitude !== null &&
                            published.searchCriteria.longitude !== undefined)
                        ? published.searchCriteria.longitude.toString()
                        : "");
                }
            }

            // resort detail data
            if (published.resortDetail !== null &&
                published.resortDetail !== undefined &&
                (ResortPageViews.ResortDetailsPreferred.endsWith(pageView) ||
                    ResortPageViews.ConfirmationPage.endsWith(pageView) ||
                    ResortPageViews.ResortDetailsStandard.endsWith(pageView) ||
                    ResortPageViews.CheckoutPage.endsWith(pageView))) {

                mergedData = this.merge({ "resortDetail": JSON.stringify(published.resortDetail) }, mergedData);

                //if no search data entered by user, on the details page or subsequent pages log the resort details location info as search info
                if ((published.searchCriteria === null || published.searchCriteria === undefined) ||
                    (published.searchCriteria !== null && published.searchCriteria !== undefined) &&
                    (published.searchCriteria.searchText === null ||
                        published.searchCriteria.searchText === undefined ||
                        published.searchCriteria.searchText === "")) {

                    mapData.set("destinationcity",
                        published.resortDetail.city +
                        " " +
                        published.resortDetail.state +
                        " " +
                        published.resortDetail.country);

                    mapData.set("lat",
                        published.resortDetail.latitude !== null && published.resortDetail.latitude !== undefined
                        ? published.resortDetail.latitude.toString()
                        : "");
                    mapData.set("long",
                        published.resortDetail.longitude !== null && published.resortDetail.longitude !== undefined
                        ? published.resortDetail.longitude.toString()
                        : "");
                }
                mapData.set("address",
                    published.resortDetail.address1 +
                    " " +
                    published.resortDetail.city +
                    " " +
                    published.resortDetail.state +
                    " " +
                    published.resortDetail.country +
                    " " +
                    published.resortDetail.zip);
                mapData.set("locationname", published.resortDetail.resortName);
                mapData.set("locationid", published.resortDetail.id.replace(/:/g, ""));
                mapData.set("resortid", published.resortDetail.id.replace(/:/g, ""));
                mapData.set("resortlat",
                    published.resortDetail.latitude !== null && published.resortDetail.latitude !== undefined
                    ? published.resortDetail.latitude.toString()
                    : "");
                mapData.set("resortlong",
                    published.resortDetail.longitude !== null && published.resortDetail.longitude !== undefined
                    ? published.resortDetail.longitude.toString()
                    : "");
            }

            //booking data
            if (published.booking !== null &&
                published.booking !== undefined &&
                (ResortPageViews.CheckoutPage.endsWith(pageView) ||
                    ResortPageViews.ConfirmationPage.endsWith(pageView))) {
                mapData.set("startdate", this.formattedDateTime(published.booking.CheckInDate));
                mapData.set("enddate", this.formattedDateTime(published.booking.CheckOutDate));
                mapData.set("numchildren",
                    (published.booking.numberOfChildren !== undefined) ? published.booking.numberOfChildren : "");
                mapData.set("numadults",
                    (published.booking.numberOfAdults !== undefined) ? published.booking.numberOfAdults : "");
                mapData.set("guestages",
                    (published.booking.guestAges !== undefined) ? published.booking.guestAges : "");

                if (published.booking.ResortInventory !== null && published.booking.ResortInventory !== undefined) {
                    mapData.set("duration", published.booking.ResortInventory.nights);
                }

            }

            let jsonObject = {};
            mapData.forEach((value, key) => {
                jsonObject[key] = value;
            });

            mergedData = this.merge(jsonObject, mergedData);

            this.appInsights.logPageView(this.getPageNameForInsights(pageView), null, mergedData);
        }
    }

    private static merge(obj1: any, obj2: any): any {

        var data: any = {};

        if (obj1 === undefined || obj1 === null) return obj2 === undefined ? null : obj2;

        if (obj2 !== undefined && obj2 !== null) {
            Object.keys(obj1).forEach(key => { data[key] = obj1[key] });
            Object.keys(obj2).forEach(key => { data[key] = obj2[key] });
            return data;
        }

        return obj1;
    }

    private static getPageNameForInsights(pageName: string) {
        if (pageName === null || pageName === undefined || pageName === "")
            return "";
        switch (pageName) {
        case ResortPageViews.SearchResults:
        case ResortPageViews.SearchPage:
            return "DestinationSearch";
        case ResortPageViews.ResortDetailsPreferred:
        case ResortPageViews.ResortDetailsStandard:
            return "ProductDetails";
        case ResortPageViews.CheckoutPage:
            return "Checkout";
        case ResortPageViews.ConfirmationPage:
            return "BookingCompletion";
        default:
            return pageName;
        }
    }

    private static formattedDateTime(date: Date) {
        if (this.isValidDate(date)) {
            return moment(date).format("YYYY/MM/DD HH:mm");
        }
        return "";
    }

    private static isValidDate(d) {
        if (d !== null && d !== undefined) {
            return d instanceof Date && !isNaN(d.getDate());
        }
        return false;
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/instrumentation/resort-insights.service.ts